export type EmailStreakPerWeek = {
  index: number;
  startAt: string;
  endAt: string;
  isCurrentWeek: boolean;
  emailCount: number;
  completed: boolean;
};

export enum OrganizationGamificationTask {
  add_template = "add_template",
  add_followup = "add_followup",
  add_portfolio = "add_portfolio",
  send_pitch = "send_pitch",
  niche_templates = "niche_templates",
  email_streak = "email_streak",
}

export type GamificationProfile = {
  id?: number;
  createdAt: number;
  tasksCompleted: OrganizationGamificationTask[];
  completed?: boolean;
  unlockPremiumFeatures?: boolean;
  // Only use on FE
  longestStreak?: number;
  emailStreaks?: EmailStreakPerWeek[];
};

export type OrganizationGamificationCredit = {
  transactionType: OrganizationGamificationTask;
  createdAt?: number;
};
